<template>
    <nav  aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" class="pt-3">
        <ul class="breadcrumb" style="font-size: 80%; margin: 0;">
            <!-- <li class="breadcrumb-item active" aria-current="page">
                <router-link :to="{ name: 'home' }">{{Object.keys(bcrumbs).length}}</router-link>
            </li> -->


            <li v-if="Object.keys(bcrumbs).length === 0" class="breadcrumb-item active" aria-current="page">
                /
            </li>


            <li v-for="(value, name, index) in bcrumbs" :key="index" class="breadcrumb-item active" aria-current="page">


                <router-link v-if="name == 'admin_departments_list'" :to="{ name: 'adminDepartments' }">Список кафедр [adm]</router-link>

                <router-link v-if="name == 'admin_courses_list'" :to="{ name: 'adminCourses' }">Список курсов</router-link>
                <router-link v-if="name == 'admin_course'" :to="{ name: 'adminCourse_show', params: { id: value[0] } }">{{ value[1] }}</router-link>
                <router-link v-if="name == 'admin_chapters_list'" :to="{ name: 'adminCourse_chapters', params: { course_id: value } }">Список глав</router-link>
                <router-link v-if="name == 'admin_chapter'" :to="{ name: 'adminChapter_show', params: { id: value[0] } }">{{ value[1] }}</router-link>
                <router-link v-if="name == 'admin_questions_list'" :to="{ name: 'adminChapter_questions', params: { chapter_id: value } }">Список вопросов</router-link>
                <router-link v-if="name == 'admin_question'" :to="{ name: 'adminQuestion_show', params: { id: value[0] } }">{{ value[1] }}</router-link>
                <router-link v-if="name == 'admin_answers_list'" :to="{ name: 'adminQuestion_answers', params: { question_id: value } }">Список ответов</router-link>

                <router-link v-if="name == 'courses_list'" :to="{ name: 'courses' }">Курсы</router-link>
                <router-link v-if="name == 'course'" :to="{ name: 'course_show', params: { id: value[0] } }">{{ value[1] }}</router-link>
                <router-link v-if="name == 'chapter'" :to="{ name: 'chapter_show', params: { id: value[0] } }">{{ value[1] }}</router-link>
                <router-link v-if="name == 'questions_list'" :to="{ name: 'questions', params: { id: value } }">Тестирование</router-link>
                        
            </li>
        </ul>
    </nav>

</template>

<script>
export default {
    props: [
        'bcrumbs',
    ],
}
</script>

<style scoped>
.breadcrumb {
  background-color: var(--color-blue-gray-10) !important;
}
</style>